import { usePartyQuery } from "Api/Queries/Party/usePartyQuery";
import { useLoggedInUser } from "Hooks/useLoggedInUser";

export const useCurrentUserParty = () => {
  const user = useLoggedInUser();
  const partyQueryResult = usePartyQuery(user?.partyPublicID);

  return partyQueryResult;
};
